






































import { Component, Vue } from 'vue-property-decorator';
import { request } from '@/rest-client';
import { AxiosResponse } from 'axios';

interface User {
  login: string;
  password: string;
}

@Component
export default class LoginForm extends Vue {
    private user: User = {
      login: '',
      password: '',
    };


    private showPassword = false;


    private redirect() {
      this.$router.push({name: 'Calendar'}).then(() => (this.$root as any).showSnackbar('Logged In'));
    }

    private parseJwt(token: string) {
      return new Promise((resolve) => {
        const base64Url = token.split('.')[1];
        const base64 = decodeURIComponent(atob(base64Url).split('').map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        resolve(JSON.parse(base64));
      });
    }

    private onClickSubmit = (credentials: User): boolean => {
      if (!credentials.login.length || !credentials.password.length) { return false; }

      request('post', `login`,
        {
          email: credentials.login,
          password: credentials.password,
        },
        {
          'Content-Type': 'application/json',
        },
      )
      .then((response) => {
        const token = response.data.accessToken;
        window.localStorage.setItem('token', token);
        this.$store.commit('currentUser/setRoles', response.data.roles);

        this.parseJwt(response.data.accessToken).then((tokenDecoded: any) => {
          this.redirect();

        });
      })
      .catch((error: any) => (this.$root as any).showSnackbar('Something went wrong', 'error'));
      return true;
    }

}
